import { Box, CircularProgress, Grid } from '@mui/material';
import { ReactNode } from 'react';

interface IndicatorCardProps {
    onClick?: () => void;
    children: ReactNode;
    value: number;
    detail?: string;
    // Reemplaza la línea de "detail" por contenido custom (p. ej. el desglose
    // Preventivas/ROAM de las cards de Visitas), sin afectar a los demás usos
    // de esta card que siguen mostrando el detail simple.
    footer?: ReactNode;
    // Muestra el número y "children" (el Chip de estado) en la misma fila,
    // numero a la izquierda y chip a la derecha, en vez del layout apilado
    // por defecto (chip arriba, numero abajo) que siguen usando el resto de
    // las cards que reutilizan este componente.
    inlineHeader?: boolean;
    loading?: boolean;
    testID?: string;
    // Alto de la card: al ser fijo y el layout "space-between", bajarlo achica
    // el espacio entre el header (número/chip) y el footer sin tocar el resto
    // de las pantallas que reutilizan este componente con el alto por defecto.
    height?: string;
}

const IndicatorCard = ({
    children,
    value,
    detail,
    footer,
    inlineHeader = false,
    onClick,
    loading = false,
    testID = 'indicator-card',
    height = '225px'
}: IndicatorCardProps) => (
    <Box
        display={'flex'}
        flexDirection={'column'}
        width={'100%'}
        borderRadius={'8px'}
        padding={2}
        justifyContent={'space-between'}
        height={height}
        sx={{ cursor: onClick ? 'pointer' : 'default', backgroundColor: 'white', overflow: 'hidden' }}
        onClick={onClick}
        data-testid={testID}
    >
        {inlineHeader ? (
            <Grid container wrap="nowrap" alignItems="center" data-testid={`${testID}-container`}>
                {/* Mismas mitades (50/50) que el footer, para que el número quede
                    centrado sobre "Preventivas" y el chip sobre "ROAM". */}
                <Grid
                    item
                    xs={6}
                    display="flex"
                    justifyContent="center"
                    data-testid={`${testID}-value`}
                    sx={{ fontSize: '64px', fontWeight: '600' }}
                >
                    {loading ? <CircularProgress /> : value !== null ? value : '-'}
                </Grid>
                <Grid item xs={6} display="flex" justifyContent="center">
                    {children}
                </Grid>
            </Grid>
        ) : (
            <>
                <Grid container data-testid={`${testID}-container`}>
                    {children}
                </Grid>
                <Grid
                    item
                    data-testid={`${testID}-value`}
                    xs={12}
                    sx={{ fontSize: '64px', fontWeight: '600' }}
                >
                    {loading ? <CircularProgress /> : value !== null ? value : '-'}
                </Grid>
            </>
        )}
        {footer ?? (
            <Grid
                item
                data-testid={`${testID}-detail`}
                xs={12}
                sx={{ fontWeight: '400', fontSize: '18px' }}
            >
                {detail || '-'}
            </Grid>
        )}
    </Box>
);

export { IndicatorCard };
